<template>
   <div>
      <nav aria-label="Navigation" itemscope itemtype="https://schema.org/SiteNavigationElement">
         <div>
            <div ref="topBar" class="navigation primary-navigation-container">
               <div class="primary-navigation-container__inner d-flex">
                  <div
                     class="navigation__logo"
                     itemscope="itemscope"
                     itemtype="https://schema.org/Organization"
                  >
                     <a href="/" itemprop="url" @click.prevent="goTo('/')">
                        <img
                           style="height:24.2px;width:100%;"
                           itemprop="logo"
                           src="../../../public/images/fusion-logo_without_yf.svg"
                           alt="FusionCharts"
                           class="logo__fc"
                     /></a>
                  </div>
                  <div class="primary-nav-desktop-only">
                     <ul class="navigation__items">
                        <li
                           v-for="(item, index) in navbarNavigationData.items"
                           v-if="!(item.header === 'Company') && !(item.header === 'Contact')"
                           :key="index"
                           class="navigation__items-item"
                        >
                           <!-- Products,Developer, Services, Company, Contact -->
                           <NavBarItems
                              v-if="item.externalProperties && item.externalProperties.dropdown"
                              :item-name="item.header"
                              :dropdown-items="item.items"
                              :sidebyside-dropdown="item.externalProperties.sidebysideDropdown"
                              :stylish-dropdown="item.externalProperties.stylishDropdown"
                              :simple-dropdown="item.externalProperties.simpleDropdown"
                           />
                           <!-- Pricing, Customers, and any other plain-link nav item -->
                           <NavBarItems
                              v-if="
                                 item.type === 'navigation' &&
                                    !(
                                       item.externalProperties && item.externalProperties.dropdown
                                    ) &&
                                    item.link
                              "
                              :item-name="item.header"
                              :item-link="item.link"
                           />

                           <!-- Contact Sales -->
                           <!--<button
                     v-if="item.type === 'cta' && item.link === '/contact-sales'"
                     class="btn btn-outline-primary navbar-btn btn-contact-sales"
                     @click="modalShowContactSales = !modalShowContactSales"
                  >
                     {{ item.header }}
                  </button>-->
                        </li>
                        <div class="al_nav_r_wrap">
                           <li
                              v-for="(item, index) in navbarNavigationData.items"
                              v-if="
                                 showDownloadBtn &&
                                    item.type === 'cta' &&
                                    item.link !== '/contact-sales'
                              "
                              :key="index"
                              class="navigation__items-item"
                           >
                              <!-- "Buy Now" keeps the old "Talk to us" plain-text-link
                                   look instead of the pill button the other CTAs
                                   (e.g. "Try FusionCharts") use. -->
                              <a
                                 v-if="item.header === 'Buy Now'"
                                 class="fc-text-link nav-talk-to-us"
                                 :href="item.link"
                                 @click.prevent="goToDownlad(item.link)"
                                 >{{ item.header }}</a
                              >
                              <a
                                 v-else
                                 :href="item.link"
                                 class="fc-pill-btn fc-pill-btn--solid fc-pill-btn--sm navbar-btn navbar-btn--download"
                                 @click.prevent="goToDownlad(item.link)"
                              >
                                 {{ item.header }}</a
                              >
                           </li>
                        </div>
                     </ul>
                  </div>

                  <!--Mobile Menu xs-->
                  <div class="primary-nav-mobile-only">
                     <div class="mobile-menu">
                        <i
                           class="mobile-menu__menu-icon fc_menu"
                           :class="{ check: showMenu }"
                           @click="menuToggle"
                        ></i>
                        <i
                           class="mobile-menu__menu-icon fc_close"
                           :class="{ check: !showMenu }"
                           @click="menuToggle"
                        ></i>
                     </div>
                  </div>

                  <!--Contact Sales-->
               </div>
            </div>

            <div class="primary-nav-mobile-only">
               <div v-show="showMenu" class="mobile-menu__panel">
                  <MobileNav :items="navbarNavigationData.items" @navigate="hideMenuMethod" />
               </div>
            </div>

            <!-- The fixed nav bar above takes up no space in normal flow, so
                 page content needs this to avoid sitting underneath it. This
                 has to be unconditional (not just the release banner's own
                 margin) - otherwise disabling the banner leaves nothing
                 reserving that height and the next section butts up against
                 the nav. -->
            <div class="primary-navigation-container__spacer" aria-hidden="true"></div>

            <transition name="release-banner" :css="releaseBannerTransitionsEnabled">
               <div
                  v-if="
                     navbarNavigationData.externalProperties.isBannerEnabled &&
                        navbarNavigationData.externalProperties.bannerText &&
                        showReleaseBanner
                  "
                  class="animate-charcter-placeholder"
               >
                  <div class="animate-charcter">
                     <div class="animate-charcter__inner">
                        <div
                           class="animate-charcter__text"
                           v-html="
                              descriptionJoiner(navbarNavigationData.externalProperties.bannerText)
                           "
                        ></div>
                        <button
                           type="button"
                           class="animate-charcter__close"
                           aria-label="Close announcement"
                           @click="closeReleaseBanner"
                        >
                           &times;
                        </button>
                     </div>
                  </div>
               </div>
            </transition>
         </div>
      </nav>
   </div>
</template>

<script>
import { mapState } from 'vuex';
// import VueCountdown from '@chenfengyuan/vue-countdown';
// import axios from 'axios';
import NavBarItems from '../navbar/NavbarItems';
import MobileNav from '../navbar/MobileNav';
// import ContactSales from '../elforms/Sales';

export default {
   name: 'PrimaryNavigation',
   components: {
      NavBarItems,
      MobileNav,
      // VueCountdown,
      // ContactSales,
   },
   data() {
      const now = new Date();
      // Below returns next monday of every week. So countdown resets every week
      const nextMonday = new Date(
         now.setDate(now.getDate() + ((7 - now.getDay() + 1) % 7 || 7))
      ).setHours(0, 0, 0);
      /* const nextDay = new Date(
       now.setDate(now.getDate() + ((1 - now.getDay() + 1) % 7 || 7))
       ).setHours(0, 0, 0); */
      return {
         newbarshow: true,
         showMenu: false,
         showReleaseBanner: true,
         // Starts false so the corrective flip in mounted() (SSR always
         // assumes visible, since it can't see the dismiss cookie) is not
         // treated as a real leave transition - see mounted() for why.
         releaseBannerTransitionsEnabled: false,
         today: new Date(),
         time: nextMonday - new Date(),
         // saleTime: nextDay - new Date(),
         // modalShowContactSales: false,
         // modalShowDecSale: false,
         showDownloadBtn: true,
         purpose_options: [
            {
               value: 'Licensing query for a SaaS application',
               text: 'Licensing query for a SaaS application',
            },
            {
               value: 'Licensing query for an on-premise application (OEM)',
               text: 'Licensing query for an on-premise application (OEM)',
            },
            {
               text: 'Licensing query for an enterprise plan',
               value: 'Licensing query for an enterprise plan',
            },
            {
               text: 'Reseller enquiry',
               value: 'Reseller enquiry',
            },
            {
               value: 'Licensing FusionExport',
               text: 'Licensing FusionExport',
            },
            { value: 'Payment through PO/Wire/Check', text: 'Payment through PO/Wire/Check' },
            { value: '​Product/Technical related query', text: '​Product/Technical related query' },
            { value: 'Other', text: 'Other' },
         ],
         country: '',
         MyIp: '',
      };
   },

   computed: {
      ...mapState(['navbarNavigationData']),
      // Cross-site dismiss contract shared with the dev center (docs) site:
      // both read/write the SAME `dismissedReleaseBannerId` cookie (path=/,
      // no domain= - the two sites share a host), storing the raw, un-hashed
      // "${version}|${text}|${link}" string for whatever release each site is
      // currently showing. A plain string compare (rather than a hash) means
      // neither codebase has to reproduce an identical hash function - they
      // just both have to agree on the three pieces that make up the string.
      // Dismissing on one site writes this exact string; the other site only
      // re-shows its banner once ITS OWN signature stops matching what's
      // stored - which requires both sites to actually be displaying the
      // same version/text/link at any given time (a content-sync concern
      // separate from this cookie mechanics).
      releaseBannerSignature() {
         // Only ever read client-side (mounted()/closeReleaseBanner()) - DOM
         // parsing below needs `document`, which SSR doesn't have.
         if (typeof document === 'undefined') return '';

         const externalProperties = this.navbarNavigationData.externalProperties || {};
         const bannerText = externalProperties.bannerText || '';
         const html = Array.isArray(bannerText) ? bannerText.join('') : String(bannerText);
         if (!html) return '';

         // bannerText's known shape (see the fc-navbar Contentful entry):
         // <div class="release-bar__in">
         //   <span class="release-tag">New release <span data-npm-version="v">vX.Y.Z</span></span>
         //   <span>description text</span>
         //   <a href="...">Read more</a>
         // </div>
         const scratch = document.createElement('div');
         scratch.innerHTML = html;
         const container = scratch.querySelector('.release-bar__in') || scratch;
         const children = Array.from(container.children);

         const versionEl = container.querySelector('[data-npm-version]');
         const version = versionEl ? versionEl.textContent.trim() : '';

         const descriptionEl = children.find(
            el => el.tagName === 'SPAN' && !el.classList.contains('release-tag')
         );
         const text = descriptionEl ? descriptionEl.textContent.trim() : '';

         const linkEl = children.find(el => el.tagName === 'A');
         const rawLink = linkEl ? linkEl.getAttribute('href') || '' : '';
         // The dev center site signs with the RAW link from its
         // vendor/docs/release-banner.json (e.g. "/upgrading/change-log"),
         // not the "/dev"-prefixed URL it actually renders as the clickable
         // href (siteUrl + prefix + link - see its releaseBannerLink
         // computed). This site's own href already has to be the real,
         // working "/dev/..." path for its "Read more" link to work here,
         // so the "/dev" prefix is stripped ONLY for the signature - the
         // rendered href (via v-html above) is untouched.
         const link = rawLink.replace(/^\/dev(?=\/|$)/, '');

         return `${version}|${text}|${link}`;
      },
   },

   watch: {
      $mq() {
         this.hidenavbars();
      },
      $route(to, from) {
         this.hideDownloadBtn();
      },
      // The mobile menu panel is position:fixed, so it never actually
      // moves when the page behind it scrolls - but on touch devices a
      // drag gesture inside the panel can still get attributed to (or
      // chain into) the body's own scroll instead of the panel's, since
      // the body was never locked while the overlay is open. That makes
      // the panel look completely frozen even though something IS
      // scrolling (just not what's visible).
      //
      // A plain `body { overflow: hidden }` (what SideBar.vue uses)
      // doesn't reliably stop this on iOS Safari - it still lets the body
      // rubber-band/scroll underneath a fixed overlay. The standard
      // iOS-safe fix is to make the body itself position:fixed at its
      // current scroll offset (via a negative top), which iOS does
      // respect, then restore the real scroll position on unlock.
      showMenu(open) {
         if (open) {
            this._lockedScrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this._lockedScrollY}px`;
            document.body.style.width = '100%';
         } else {
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            window.scrollTo(0, this._lockedScrollY || 0);
         }
      },
   },

   asyncData({ store }) {
      return Promise.all([
         store.dispatch('NAVBAR_NAVIGATION_DATA_FETCH', {
            section: 'fc-navbar',
            stateName: 'navbarNavigationData',
         }),
      ]);
   },
   mounted() {
      // Not in created(): mutating showReleaseBanner there changes what the
      // client's FIRST render produces versus what the server rendered
      // (the server has no cookie access, so it always assumes visible).
      // That mismatch is exactly the kind of thing Vue's hydration can
      // silently give up on reconciling in a production build (no [Vue
      // warn], nothing in the console) - it keeps the DOM node but drops
      // the event listeners it would have attached, which is why the close
      // button stopped doing anything on the deployed site even though
      // this same change looked fine locally in dev mode, where mismatches
      // are loud and Vue still patches things up. mounted() runs after
      // hydration has already reconciled against the server's markup, so
      // this correction can't cause that mismatch - see
      // index.template.html's inline script for how the pre-hydration
      // flash is handled instead, without touching Vue's own render data.
      // releaseBannerTransitionsEnabled starts false (see data()), so this
      // v-if flip is applied instantly, with no leave transition - it has
      // to be, since <transition> can't tell "visitor just clicked close"
      // apart from "mounted() correcting the SSR default" (the server
      // always renders the banner visible, since it can't see the dismiss
      // cookie). Without this, the 0.32s/0.22s leave animation - meant to
      // ease the page up smoothly on an actual close click - played out
      // in full on *every* reload for a visitor who'd already dismissed
      // it, which looked exactly like the flash this is meant to avoid.
      const dismissedCookie = this.getCookie('dismissedReleaseBannerId');
      const dismissedSignature =
         dismissedCookie === null ? null : decodeURIComponent(dismissedCookie);
      this.showReleaseBanner = dismissedSignature !== this.releaseBannerSignature;
      if (typeof document !== 'undefined') {
         // $nextTick: wait until that instant correction has actually
         // reached the DOM before (a) turning transitions back on, so a
         // *later*, real close click still animates, and (b) clearing the
         // blunt pre-hydration CSS hide - clearing it any earlier would
         // leave a tick where neither mechanism is hiding the banner.
         this.$nextTick(() => {
            this.releaseBannerTransitionsEnabled = true;
            document.documentElement.classList.remove('release-banner-maybe-dismissed');
         });
      }

      /* if (this.getCookie('modalShowSalefab')) {
               this.modalShowSale = false;
            } else  {
              setTimeout(() => this.modalShowSale = true, 3000);
            } */

      /* axios
      .get('https://api.ipify.org/?format=json')
      .then(response => {
         // debugger;
            if (response.status === 200) {
            this.MyIp = response.data.ip
            }
         });


      axios
         .get(`https://www.iplocate.io/api/lookup/${this.MyIp}`)
         .then(response => {

            if (response.status === 200) {
            if (this.getCookie('modalShowDecSale')) {
               this.modalShowDecSale = false;
            } else if (response.data.country_code === ('IN' || 'BR' || 'DE' || 'JP' || 'ID')) {
              // setTimeout(() => this.modalShowSaledec = true, 3000);
                setTimeout(() => this.modalShowDecSale = true, 3000);
            }
            }
         }); */

      this.hidenavbars();
      this.hideDownloadBtn();
      // hidenavbars() also decides --fc-header-offset by the same
      // desktop-or-not split as the nav itself (see its own comment) -
      // the $mq watcher above only fires when vue-mq's OWN breakpoints
      // are crossed, which no longer lines up with this nav's plain-CSS
      // 1025px split, so resizing between (say) 1030px and 1020px
      // wouldn't otherwise call it again.
      window.addEventListener('resize', this.hidenavbars);
   },
   beforeDestroy() {
      window.removeEventListener('resize', this.hidenavbars);
   },
   methods: {
      closeReleaseBanner() {
         this.showReleaseBanner = false;
         this.setCookie(
            'dismissedReleaseBannerId',
            encodeURIComponent(this.releaseBannerSignature),
            365
         );
      },
      gotocontact() {
         window.location.href = 'https://www.fusioncharts.com/contact-sales?ba=1';
      },
      transformSlotProps(props) {
         const formattedProps = {};

         Object.entries(props).forEach(([key, value]) => {
            formattedProps[key] = value < 10 ? `0${value}` : String(value);
         });

         return formattedProps;
      },
      menuToggle() {
         this.showMenu = !this.showMenu;
      },
      hideMenuMethod() {
         this.showMenu = false;
      },
      goTo(url) {
         if (url === '/') {
            this.showMenu = false;
         }
         this.$router.push(url).catch(() => {});
      },
      hideDownloadBtn() {
         if (this.$route.path.indexOf('/download') > -1) {
            this.showDownloadBtn = false;
         } else {
            this.showDownloadBtn = true;
         }
      },
      hidenavbar() {
         const val = this.$mq; // current breakpoint
         if (val === 'sm' || val === 'xs' || val === 'md') {
            this.$refs.topBar.style.top = '0px';
         } else {
            this.$refs.topBar.style.top = '42px';
         }
      },
      hidenavbars() {
         this.newbarshow = false;
         // if (this.$route.path.indexOf('/fusioncharts-ai') > -1) {
         // The release banner is normal-flow now (not fixed), so it pushes page
         // content down on its own - this offset only ever needs to account for
         // the fixed header itself, regardless of whether the banner is showing.
         // Matches .primary-nav-desktop-only's own 1025px split (see that
         // rule's comment) - not $mq, which no longer lines up with it.
         const isDesktop = typeof window !== 'undefined' && window.innerWidth >= 1025;
         const barHeight = isDesktop ? 64 : 54;
         document.documentElement.style.setProperty('--fc-header-offset', `${barHeight}px`);
         // debugger;
         // console.log('asasd');
         // debugger;
         /* if (typeof geoip2 !== 'undefined') {
            geoip2.country(locationInfo => {
               this.country = locationInfo.country.iso_code;
               // console.log(`asasd${this.country}`);
               if (this.getCookie('modalShowSale')) {
                  this.modalShowSale = false;
               } else if (this.country === ('IN' || 'BR' || 'DE' || 'JP' || 'ID')) {

                    // this.modalShowSale = true;
                  // setTimeout(() => this.modalShowSale = true, 3000);
               }
            });
         } */
         /* if (this.getCookie('newbarshow')) {
            this.newbarshow = false;
            this.$refs.topBar.style.top = '0px';
         } else {
            this.$refs.topBar.style.top = '50px';
            this.newbarshow = true;
         } */
      },
      goToDownlad(link) {
         if (this.$reloadType(link)) {
            this.$openReload(link);
            return;
         }
         const fw = this.$route.query.framework || this.$getUserSelectedFramework();
         let _link = link;
         if (fw) {
            _link = `${link}?framework=${fw}`;
         }
         this.$router.push(_link).catch(() => {});
      },

      setCookie(name, value, days) {
         let expires = '';
         if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = `; expires=${date.toUTCString()}`;
         }
         document.cookie = `${name}=${value || ''}${expires}; path=/`;
      },
      getCookie(name) {
         const nameEQ = `${name}=`;
         const ca = document.cookie.split(';');
         for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
         }
         return null;
      },
   },
};
</script>

<style lang="scss" scoped>
.primary-navigation-container {
   position: fixed;
   left: 0;
   top: 0;
   z-index: 1000;
   background: #ffffff;
   height: 64px;
   width: 100%;
   // overflow: hidden;
   border-bottom: 1px solid #e6e8ef;
   // Matches .primary-nav-desktop-only's own 1025px split (see that
   // rule's comment) and hidenavbars()'s isDesktop check - keep all
   // three in sync, or the nav's own height/padding disagrees with
   // which content (hamburger vs full items row) it's actually showing.
   @media (max-width: 1024px) {
      height: 54px;
   }

   &__inner {
      position: relative;
      height: 100%;
      max-width: 1360px;
      margin: 0 auto;
      padding: 0 54px;
      @media (max-width: 1024px) {
         padding: 0 15px;
      }
      @media (min-width: 1025px) and (max-width: 1190px) {
         padding: 0 38px;
      }
   }

   .mobile-menu {
      height: 100%;
      position: relative;
      transition: all 0.35s ease;
      &__menu-icon {
         color: rgba(49, 49, 49, 0.6);
         position: absolute;
         top: 50%;
         right: 4px;
         transform: translateY(-50%);
         transition: all 0.35s ease;
         opacity: 1;
         visibility: visible;
         cursor: pointer;
      }
   }
}

.mobile-menu__panel {
   position: fixed;
   top: 54px;
   left: 0;
   right: 0;
   bottom: 0;
   width: 100%;
   z-index: 999;
   background-color: #ffffff;
   border-bottom: 1px solid #e6e8ef;
   box-shadow: 0 12px 24px -12px rgba(11, 11, 40, 0.15);
   // The single scroll owner for this menu now - previously only the inner
   // .fc-mobile-nav had overflow-y: auto while this fixed-position parent
   // had no bottom/height/overflow of its own, so the scrollable region's
   // actual boundary was ambiguous to the browser. Nested overflow:auto
   // inside position:fixed with no bounded ancestor is a common source of
   // touch-drag-doesn't-scroll bugs on mobile; anchoring bottom:0 here and
   // owning the scroll at this level removes that ambiguity.
   overflow-y: auto;
   -webkit-overflow-scrolling: touch;
   touch-action: pan-y;
}

.navigation__logo {
   //overflow: hidden;
   display: flex;
   align-items: center;
   width: 200px;
   flex-shrink: 0;
   .logo__fc {
      max-width: 100%;
      height: 24.2px;
      cursor: pointer;
      // The source SVG is brand navy (#363B8B), not black - force it to pure
      // black to match https://www.fusioncharts.com/fusioncharts-poc/ instead
      // of hand-editing every fill in fusion-logo_without_yf.svg.
      filter: brightness(0);
   }
}
.primary-nav-desktop-only,
.primary-nav-mobile-only {
   // Whichever of the two is actually visible needs to grow to fill the
   // row (or .navigation__items' width:100% just shrink-wraps its
   // content instead of reaching the true right edge, and the
   // hamburger icon's position:absolute;right:0 - see .mobile-menu -
   // has no real width to anchor "right" against, collapsing toward
   // the header's center instead of its right edge). Previously this
   // lived on a fragile `.navigation__logo + div` (adjacent-sibling)
   // selector that only worked because just ONE of these two ever
   // existed in the DOM at a time (the other's mq-layout wouldn't even
   // render it) - now both always exist (see the comment below), so it
   // needs their real names instead of relying on DOM order.
   flex: 1 1 auto;
   min-width: 0;
}
.primary-nav-desktop-only {
   display: none;
}
.primary-nav-mobile-only {
   display: block;
}
// Deliberately plain CSS, not the site-wide $mq/vue-mq breakpoint system
// (util/breakpoints.js's "navigation": 1080) - that value is shared by
// several unrelated components for their own responsive decisions, so
// changing it to move just this nav's own mobile/desktop split would
// have shifted theirs too. Both variants are now always in the DOM on
// server and client alike (no more v-if picking one based on a guessed
// default breakpoint pre-hydration) - only this CSS decides which one
// paints, which also sidesteps any hydration-mismatch risk entirely
// (see PrimaryNavigation.vue's mounted() comment on the release-banner
// bug this session hit from exactly that class of mismatch).
@media (min-width: 1025px) {
   .primary-nav-desktop-only {
      display: block;
   }
   .primary-nav-mobile-only {
      display: none;
   }
}
.navigation__items {
   display: flex;
   align-items: center;
   justify-content: flex-end;

   width: 100%;
   height: 100%;
   margin: 0;
   padding: 0;
   &-item {
      list-style-type: none;
      // Stretched to the row's full height (overriding the parent's own
      // align-items:center) instead of shrink-wrapping to content, and
      // re-centers its own content via flex - otherwise .nav-item's hover
      // zone was only as tall as its link text, leaving a dead strip below
      // it that was still visibly inside the nav bar but not part of any
      // hoverable box, closing the dropdown the moment the cursor crossed it.
      display: flex;
      align-items: center;
      align-self: stretch;
   }
   .navbar-btn {
      font-size: 14px;
      line-height: 14px;
      margin-left: 20px;
      padding: 10px 16px;
   }
   .navbar-btn--download {
      margin-left: 6px;
      font-family: basefontSemiBold, 'Helvetica Neue', Arial, sans-serif;
   }
   .nav-talk-to-us {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-left: 6px;
      padding: 8px 12px;
      color: #3c415c;
      font-size: 15px;
      white-space: nowrap;
      cursor: pointer;
   }
   /*@media (min-width: 800px) {
      .btn-contact-sales {
         margin-left: 65px;
      }
   }*/
}
.navigation > div:last-child {
   width: 100%;
}
.active {
   visibility: visible !important;
   transform: translateX(0) !important;
   opacity: 1 !important;
}
.stcky-nav {
   position: fixed;
   bottom: 0;
   width: 100%;
   left: 0;
   background-color: teal;
   display: flex;
   height: 200px;
}
.check {
   visibility: hidden !important;
   opacity: 0 !important;
}

@media screen and (min-width: 1024px) {
   .al_nav_r_wrap {
      width: 100%;
      display: flex;
      justify-content: flex-end;
   }
}
</style>
<style>
@media screen and (min-width: 728px) {
   .modal-ms {
      width: 26% !important;
   }
}
.modal-ms {
   background: #f8f9fd;
}
.saleTimer.display-3.lead {
   padding: 11px;
   display: flow-root;
}
span.saleTimer.display-3.lead span {
   background-color: #eeeee4;
   padding: 3px 6px;
   border-radius: 9px;
   width: 51px !important;
   display: inline-block;
}
</style>
<style lang="scss" scoped>
// Reserves the fixed nav's height in normal flow - see the template comment
// where this is inserted. Tracks the same --fc-header-offset value the nav
// itself maintains on resize (64px desktop / 54px below 1025px), so it can't
// drift out of sync with the nav's actual height the way a hardcoded value
// would.
.primary-navigation-container__spacer {
   // Fallbacks only apply until hidenavbars() sets --fc-header-offset in
   // mounted() - split by the same 1025px switch as the nav itself, so the
   // reserved height is already right on first paint instead of jumping
   // from 64px to 54px at hydration on mobile/tablet widths.
   height: var(--fc-header-offset, 54px);
   @media (min-width: 1025px) {
      height: var(--fc-header-offset, 64px);
   }
}

.animate-charcter-placeholder {
   width: 100%;
}

// Closing the banner removes it from the DOM (v-if) - without a transition
// that's an instant jump-cut. Animate max-height/opacity/margin-top down to
// 0 together so the page content above it eases up smoothly instead.
.release-banner-leave-active {
   transition: max-height 0.32s ease, opacity 0.22s ease, margin-top 0.32s ease;
   overflow: hidden;
}
.release-banner-leave {
   max-height: 160px;
}
.release-banner-leave-to {
   max-height: 0;
   margin-top: 0;
   opacity: 0;
}

.animate-charcter {
   width: 100%;
   background: #0b0b28;
   color: #a6abc6;
   display: flex;
   align-items: center;
   justify-content: flex-start;
}

.animate-charcter__inner {
   width: 100%;
   max-width: 1360px;
   margin: 0 auto;
   padding: 11px 54px;
   display: flex;
   align-items: center;
   justify-content: flex-start;
   overflow: hidden;
}

.animate-charcter__close {
   flex: 0 0 auto;
   margin-left: 16px;
   width: 22px;
   height: 22px;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   border: none;
   background: transparent;
   color: #a6abc6;
   font-size: 20px;
   line-height: 1;
   cursor: pointer;
   opacity: 0.7;
   transition: opacity 0.14s ease;

   &:hover {
      opacity: 1;
      color: #fff;
   }
}

.animate-charcter__text {
   text-align: left;
   overflow: hidden;
   flex: 1 1 auto;
   min-width: 0;

   ::v-deep b,
   ::v-deep strong {
      color: #fff;
   }
   ::v-deep .release-bar__in {
      display: flex;
      align-items: center;
      gap: 14px;
      flex-wrap: wrap;
      font-size: 15px;
   }
   ::v-deep .release-tag {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      background: rgba(32, 201, 165, 0.13);
      color: #79dcc4;
      border: 1px solid rgba(32, 201, 165, 0.26);
      font-weight: 600;
      font-size: 15px;
      letter-spacing: 0.01em;
      padding: 3px 11px;
      border-radius: 99px;
      white-space: nowrap;
   }
   ::v-deep a {
      color: #fff;
      font-weight: 600;
      text-decoration: underline;
      text-underline-offset: 3px;
      white-space: nowrap;

      &:hover {
         color: #20c9a5;
      }
   }
}

// 1024px, not some narrower phone-only breakpoint - this must match (or
// exceed) .primary-nav-desktop-only's own split exactly, since that's
// what actually swaps in the hamburger menu. Below that same width,
// banner content is squeezed into the nav's own narrower 15px side
// padding and wraps onto two lines, so the nav no longer being
// desktop-only meant *this* range needed its own layout too, not just
// phone-width viewports - a narrower rule here left the whole
// 729-1024px band (a real device size, e.g. landscape phones/small
// tablets) on the old center-aligned, no-vertical-padding desktop rule.
@media (max-width: 1024px) {
   .animate-charcter__inner {
      // align-items:center (fine on desktop's single line) would center
      // the close button against the whole wrapped two-line block instead
      // of pinning it to the top-right corner - flex-start fixes that.
      align-items: flex-start;
      padding: 22px 15px;
   }
   .animate-charcter__close {
      margin-left: 12px;
   }
}
</style>
<style scoped>
.fc-dev-ai-item {
   width: 100%;
   display: flex;
}
.fc-dev-ai-icon-text {
   vertical-align: middle;
}
.fc-dev-ai-icon {
   background-image: url(/public/images/chat-feedback/ask-fc-dev-icon.svg);
   height: 24px;
   width: 23px;
   display: inline-block;
   background-repeat: no-repeat;
   /* margin-right: 4px; */
   vertical-align: middle;
}
.new-label-ai {
   margin-left: 5px;
   background-color: #da3224;
   color: white;
   padding: 0px 5px;
   border-radius: 5px;
   font-size: 12px;
   font-weight: bold;
   margin-top: -7px;
}
.navigation__items-item.fc-dev-ai-item .nav-item {
   display: flex;
   align-items: flex-start;
}
/*.carousel-container ::v-deep .VueCarousel-dot-container {
  display: none;
}
 Optional: Add styles for the carousel container
.carousel-container {
  max-width: 800px;
  margin: 0 auto;
}*/
</style>
